import { render, staticRenderFns } from "./SalesLoader.vue?vue&type=template&id=009b11ae"
import script from "./SalesLoader.vue?vue&type=script&lang=ts"
export * from "./SalesLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports